module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-17.35a137f2.png";